import * as types from '../../actionTypes';

const initialState = {
    medicineMasterInfo: [],
    error: {},
    loading: false
}


export const medicineMasterReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.MEDICINE_MASTER_LOADING:
            return {
                ...state,
                loading: true
            }
        case types.MEDICINE_MASTER_SUCCESS:
            console.log("action.payload",action.payload)
            return {
                ...state,
                medicineMasterInfo: action.payload,
                loading: false,
                error: {}
            }
        case types.MEDICINE_MASTER_FAIL:
            return{
                ...state,
                error: action.payload,
                loading: false,
            } 


        default:
            return state;
    }
}